import Router from "../..";
import { useUserStore } from "../../../stores/userStore";

export const InfluencerManagement = () => {
  const { userInfo } = useUserStore();

  const isAgency = userInfo?.user_info?.user_type === "agency";

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">크리에이터 관리</h2>
      <div className="w-full max-w-[600px]">
        {isAgency && userInfo?.type_info && (
          <Router.InfluencerManagementContent />
        )}
      </div>
    </div>
  );
};
